















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class RatingChange extends Vue {
  @Prop() private rating!: string;
  @Prop() private change!: string;

    get changedRating() {
      return parseInt(this.rating, 10) + parseInt(this.change, 10);
    }
    get absChange() {
      return Math.abs(parseInt(this.change, 10));
    }
}
